import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "notes" }
const _hoisted_2 = { class: "notes__actions" }
const _hoisted_3 = {
  key: 0,
  "data-test": "note",
  class: "notes__note"
}
const _hoisted_4 = {
  key: 1,
  "data-test": "note-empty",
  class: "notes__empty"
}
const _hoisted_5 = {
  key: 2,
  "data-test": "note-meta",
  class: "notes__meta"
}
const _hoisted_6 = {
  key: 3,
  class: "notes__foot"
}

import { computed, nextTick, onMounted, ref } from 'vue'

import { isNotesAttribute, NOTES_KEY } from '@/components/customers/profile/notesKey'
import RecordButton from '@/components/customers/record/RecordButton.vue'
import { useToast } from '@/composables/useToast'
import { MEDIUM_DATE } from '@/helpers/dates'
import api from '@/store/api'


export default {
  __name: 'ProfileNotes',
  props: {
  conversationUserPairId: { type: String, required: true },
  editable: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const { showToast } = useToast()

const note = ref({ id: null, value: '', updatedAt: null })
const editing = ref(false)
const draft = ref('')
const field = ref(null)

const endpoint = () => `conversation_user_pairs/${props.conversationUserPairId}/custom_attributes`

const toNote = attr => ({
  id: attr.attributes.id,
  value: attr.attributes.value_string ?? '',
  updatedAt: attr.attributes.updated_at ?? null
})

const editedOn = computed(() => {
  const date = note.value.updatedAt ? new Date(note.value.updatedAt) : null
  return date && !isNaN(date.getTime()) ? MEDIUM_DATE.format(date) : ''
})

const notePayload = value => ({ custom_attribute: { key_string: NOTES_KEY, value_string: value } })

const startEditing = async () => {
  draft.value = note.value.value
  editing.value = true
  await nextTick()
  const input = field.value
  if (!input) return
  input.focus()
  input.setSelectionRange(draft.value.length, draft.value.length)
}

const saveNote = () => {
  const request = note.value.id
    ? api.call('PUT', `${endpoint()}/${note.value.id}`, notePayload(draft.value))
    : api.call('POST', endpoint(), notePayload(draft.value))
  request
    .then(response => {
      note.value = toNote(response.data.data)
      editing.value = false
    })
    .catch(() => showToast("Couldn't save the note. Please try again.", { type: 'error' }))
}

onMounted(() => {
  api.call('GET', endpoint()).then(response => {
    const attr = response.data.data.find(isNotesAttribute)
    if (attr) {
      note.value = toNote(attr)
      return
    }
    api.call('POST', endpoint(), notePayload('')).then(created => {
      note.value = toNote(created.data.data)
    })
  })
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (editing.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          "data-test": "note-form",
          class: "notes__form",
          onSubmit: _withModifiers(saveNote, ["prevent"])
        }, [
          _withDirectives(_createElementVNode("textarea", {
            ref_key: "field",
            ref: field,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((draft).value = $event)),
            class: "notes__input",
            rows: "5",
            placeholder: "Write a note for your team",
            "aria-label": "Note"
          }, null, 512), [
            [_vModelText, draft.value]
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(RecordButton, {
              type: "submit",
              variant: "primary",
              size: "sm"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Save note", -1)
              ]))]),
              _: 1
            }),
            _createVNode(RecordButton, {
              variant: "quiet",
              size: "sm",
              onClick: _cache[1] || (_cache[1] = $event => (editing.value = false))
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            })
          ])
        ], 32))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (note.value.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(note.value.value), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "No notes yet.")),
          (note.value.value && editedOn.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Last edited " + _toDisplayString(editedOn.value), 1))
            : _createCommentVNode("", true),
          (__props.editable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(RecordButton, {
                  "data-test": "edit-note",
                  size: "sm",
                  onClick: startEditing
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(note.value.value ? 'Edit note' : 'Add note'), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

}